<template>
  <div class="flex h-full flex-col gap-4 overflow-x-hidden text-white">
    <TopBar class="mb-2" title="HISTÓRICO" :show-back-button="false" :show-toggle="false" />

    <div v-if="isLoading" class="flex flex-1 items-center justify-center">
      <span class="text-gray-400">Carregando histórico...</span>
    </div>

    <div
      v-else-if="historyData.length === 0"
      class="flex flex-1 flex-col items-center justify-center text-center"
    >
      <icon-history class="mb-4 h-16 w-16 text-gray-500" />
      <p class="text-gray-400">Nenhum apontamento encontrado.</p>
    </div>

    <div v-else class="flex flex-col gap-4">
      <div v-if="historyData.length > 0" class="mb-2 mt-1 px-1">
        <p class="text-[11px] font-semibold uppercase tracking-wider text-gray-500">
          Linha de Produção
        </p>
        <p class="mt-0.5 text-sm font-bold text-white">
          {{ productionSequence }} •
          <span class="text-xs uppercase text-neon-green">{{ operation }}</span>
        </p>
      </div>

      <div class="-mb-1 flex items-center justify-between px-1">
        <span class="text-[10px] font-bold uppercase tracking-wider text-gray-500">
          {{ historyData.length }} {{ historyData.length === 1 ? 'Item' : 'Itens' }}
        </span>
      </div>

      <HistoryItemCard v-for="(item, index) in historyData" :key="index" :item="item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import TopBar from '@/components/TopBar/TopBar.vue'
import HistoryItemCard from '@/components/HistoryItemCard.vue'
import { ref, onMounted } from 'vue'
import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import type { ProductionDataDto } from '@/services/WarrantyApiService/types'
import { IconHistory } from '@tabler/icons-vue'

const isLoading = ref(true)
const historyData = ref<ProductionDataDto[]>([])
const productionSequence = ref('-')
const operation = ref('-')

onMounted(async () => {
  await fetchHistory()
})

async function fetchHistory() {
  isLoading.value = true
  const result = await WarrantyApiService.listProductionData()
  isLoading.value = false

  if (result.isRight()) {
    historyData.value = result.value.history
    productionSequence.value = result.value.productionSequence
    operation.value = result.value.operation
  } else {
    console.error('Failed to load history', result.value)
  }
}
</script>
